import GuidanceScore from './guidance-score/guidance-score';
import OverallSentiment from './overall-sentiment/overall-sentiment';
import SuggestionSummary from './suggestion-summary/suggestion-summary';
import styles from './ccf-rtig.module.scss';
import { useEffect } from 'react';
import {
  ccfrtigActions,
  selectguidanceScoreList,
  selectOverallSentiment,
  selectsuggestionsList,
} from './+state/ccf-rtig.slice';
import { useSelector, useDispatch } from 'react-redux';
import { OverAll_Sentiment_Metric } from './rtigScore';
import { activeContactSelector, getContacts } from '../ccf-inbox/ccf-inbox.slice';
import { MediaType } from '@nice-ccf/core-sdk';
import { getContactSentiment, globalActions } from '../global.app.slice';

/* eslint-disable-next-line */
export interface CCfRtigProps {
  rtigState:any;
}

/**
 * Component to Render RTIG Score for voice contact
 * @param param0 - CCfRtigProps
 * @example - <CCfRtig />
 * @returns
 */
export function CCfRtig(props: any) {
  const contactCard = useSelector(activeContactSelector);
  const guidenceList = useSelector(selectguidanceScoreList);
  const overallSentiment = useSelector(selectOverallSentiment);
  // const suggestionsList = useSelector(selectsuggestionsList);
  const sentimentData = useSelector(getContactSentiment);
  const { setContactSentiment } = globalActions;
  const dispatch = useDispatch();
  const imageSrc = overallSentiment.image_src
    ? overallSentiment.image_src
    : 'meh';
  const {
    displayConfiguredMetricsOnly,
    updateGuidanceScores,
    showSuggestionNotifications,
    setRTIGStateForContact,
  } = ccfrtigActions;

 

  useEffect(() => {
    dispatch(
      displayConfiguredMetricsOnly({
        configuredMetrics: [OverAll_Sentiment_Metric],
      })
    );
    dispatch(setRTIGStateForContact(contactCard?.agentAssist));
  }, []);

  useEffect(() => {
    return console.log("RTIG Comp unmounnted!");
  }, []);

  useEffect(() => {
    let callCount = 1;
    const repeater = setInterval(function () {
      if (
        contactCard?.media === MediaType.VOICE &&
        contactCard?.agentAssistStatus
      ) {
        const cardIndex = randomIntFromInterval(0, 10);
        const notificationCard = contactCard?.agentAssist?.guidanceScoreList[cardIndex];
        const score =
          contactCard?.agentAssistStatus === 'Positive Score'
            ? randomIntFromInterval(72, 100)
            : contactCard?.agentAssistStatus === 'Negative Score'
            ? randomIntFromInterval(4, 29)
            : randomIntFromInterval(32, 68);
        const rtigGuidenceScore = [
          {
            score,
            guid: notificationCard.guid,
            valid: true,
            overAllSentiment: true,
          },
        ];
        dispatch(updateGuidanceScores({ enlightenResults: rtigGuidenceScore }));
        const rtigOverallScore = [
          {
            score,
            guid: 'f090fad6-f869-4a87-a137-455160de6968',
            valid: true,
            overAllSentiment: true,
          },
        ];
        dispatch(updateGuidanceScores({ enlightenResults: rtigOverallScore }));
        if (contactCard.agentAssist?.suggestionsList.length < 10 && callCount < 11) {
          const notificationData = {
            guid: notificationCard.guid,
            alertDescription: notificationCard.alertDescription, // notificationCard.alertMsg
            score,
          };
          dispatch(
            showSuggestionNotifications({ notification: notificationData })
          );
          callCount += 1;
        }
      }
    }, 10000); // update timer for every 10 seconds
    return () => {
      clearInterval(repeater);
    };
  }, []);

  useEffect(() => {
    if (
      contactCard?.media === MediaType.DIGITAL &&
      contactCard?.channel === 'Chat' &&
      sentimentData.show
    ) {
      const notificationCard = contactCard.agentAssist?.guidanceScoreList.filter((guidenceItem:any) => guidenceItem.frienly_name === sentimentData.cardName);
      const score =
        sentimentData.sentiment === 'Positive Score'
          ? randomIntFromInterval(72, 100)
          : sentimentData.sentiment === 'Negative Score'
          ? randomIntFromInterval(4, 29)
          : randomIntFromInterval(32, 68);
      const rtigGuidenceScore = [
        {
          score,
          guid: notificationCard[0].guid,
          valid: true,
          overAllSentiment: true,
        },
      ];
      dispatch(updateGuidanceScores({ enlightenResults: rtigGuidenceScore }));
      const rtigOverallScore = [
        {
          score,
          guid: 'f090fad6-f869-4a87-a137-455160de6968',
          valid: true,
          overAllSentiment: true,
        },
      ];
      dispatch(updateGuidanceScores({ enlightenResults: rtigOverallScore }));
      if (contactCard.agentAssist?.suggestionsList.length < 10) {
        const notificationData = {
          guid: notificationCard[0].guid,
          alertDescription: notificationCard[0].alertDescription, // notificationCard.alertMsg
          score,
        };
        dispatch(
          showSuggestionNotifications({ notification: notificationData })
        );
      }
      dispatch(setContactSentiment({ show: false, sentiment: '', cardName:'' }));
      return;
    }
  }, [sentimentData.show]);

  /**
   * Function to provide random integer value for percentage score
   * @param min - number
   * @param max - number
   * @example - randomIntFromInterval(10, 40)
   * @returns
   */
  function randomIntFromInterval(min: number, max: number) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  return (
    <div className={styles.rtig_container}>
      <div className={styles.overall_sentiment_section}>
        <OverallSentiment
          radius="60"
          percentage={overallSentiment.percentage}
          imageSrc={imageSrc}
        ></OverallSentiment>
      </div>
      <div style={{ overflow: 'scroll', maxHeight: '80%' }}>
        <SuggestionSummary></SuggestionSummary>
        <GuidanceScore guidanceScoreList={guidenceList}></GuidanceScore>
      </div>
    </div>
  );
}

export default CCfRtig;
